(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-philosophy"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initPhilosophy = (root) => {
    if (!root || root.dataset.cpInitialized === 'true') return;
    root.dataset.cpInitialized = 'true';

    const motionEnabled = root.dataset.animationEnabled === 'true';
    const replay = root.dataset.replay === 'true';

    if (!motionEnabled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('is-visible');
      return;
    }

    root.classList.add('cp-philosophy--motion');

    const show = () => root.classList.add('is-visible');
    const hide = () => root.classList.remove('is-visible');

    if (!('IntersectionObserver' in window)) {
      show();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          show();
          if (!replay) observer.unobserve(root);
        } else if (replay) {
          hide();
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    observer.observe(root);
    root._cpPhilosophyObserver = observer;
  };

  const mount = (container) => {
    const root = container?.matches?.('[data-cp-philosophy]')
      ? container
      : container?.querySelector?.('[data-cp-philosophy]');
    if (root) initPhilosophy(root);
  };

  mount(document);

  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target?.querySelector?.('[data-cp-philosophy]');
    if (root?._cpPhilosophyObserver) root._cpPhilosophyObserver.disconnect();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
